import { memo, useEffect, useState } from 'react';
import { TextArea, AnimationContainer } from '@/sub-luca-plugin/compatible-components';
import { teacher_qa_appraisal } from '@/sub-luca-plugin/apis';
import { satisfiedList, getCommentDesc } from '../dialogue-area/question-comment/helper';
import { eventBusExample } from '@/sub-luca-plugin/utils/class-example';
import { INoticeData } from '@/sub-luca-plugin/types';
import { getQaStore } from '@/sub-luca-plugin/store/qa';
import { preventScroll } from '@/sub-luca-plugin/compatible-components/scroll-view/helper';
import { tCommon } from '@/sub-luca-plugin/i18n';
import './index.scss';

const EvaluteModal = () => {
    const [content, setContent] = useState(''); // 评价值
    const [dialogInfo, setDialogInfo] = useState<{ starLevel: number; lucaAskChatId?: string; askId?: number }>({ starLevel: 0 }); // 是否打开弹窗

    const handleCancel = () => {
        setDialogInfo({ starLevel: 0 });
        setContent('');
        preventScroll();
    };

    const handleSubmit = async () => {
        const { status } = await teacher_qa_appraisal({ ...dialogInfo, content });
        if (status === 0) {
            handleCancel();
            getQaStore()?.updateQaConfig({ appraiseState: 1, appraise: { content, starLevel: dialogInfo.starLevel } });
            getQaStore()?.filterQaRecords({ qaNumUsedUp: true });
        }
    };

    useEffect(() => {
        eventBusExample.subscribe('EvaluteModal', ({ type, params }: INoticeData) => {
            if (type === 'open') {
                setDialogInfo(params as any);
            }
        });
    }, []);

    return dialogInfo.starLevel > 0 ? (
        <div className="comment-modal">
            <AnimationContainer className="modal-content" type="from_small_to_big" canExcuteAimation={true}>
                <div>{tCommon.t('submitReview', '发表评价')}</div>
                <div>{tCommon.t('reviewSubmissionNotice', '提交评价后，该提问将不可再追问哦～')}</div>
                <div className="handle-comment">
                    <AnimationContainer type="jitter_up_and_down" canExcuteAimation={true}>
                        <img src={satisfiedList[dialogInfo.starLevel - 1]} />
                    </AnimationContainer>
                    {getCommentDesc()[dialogInfo.starLevel - 1]}
                </div>
                <TextArea
                    className="comment-modal__textarea"
                    placeholder={tCommon.t('feedbackPrompt', '描述具体原因，您的反馈会帮助我们做得更好～')}
                    maxLength={500}
                    value={content}
                    adjustPosition={false}
                    onChange={(e: any) => setContent(e.target.value)}
                />
                <div className="btn-box">
                    <div onClick={handleCancel}>{tCommon.t('cancelAction', '取消')}</div>
                    <div onClick={handleSubmit}>{tCommon.t('submitAction', '提交')}</div>
                </div>
            </AnimationContainer>
        </div>
    ) : null;
};

export default memo(EvaluteModal);
